export default __webpack_public_path__ + "static/media/downarrow.234284cf.svg";